const DEBUG_STORAGE_KEY = "shuttlescore_analytics_debug";

export function getAnalyticsDebugStorageKey() {
  return DEBUG_STORAGE_KEY;
}

export function persistAnalyticsDebugLocalFromEnv() {
  if (process.env.NODE_ENV !== "development") return;
  if (process.env.REACT_APP_ANALYTICS_DEBUG !== "true") return;
  if (!isBrowserRuntime()) return;
  try {
    window.localStorage.setItem(DEBUG_STORAGE_KEY, "1");
  } catch {
    /* storage blocked */
  }
}

/**
 * One-time dev hint when measurement ID is set but collection is gated off.
 */
export function logDevAnalyticsConfigurationHint() {
  if (process.env.NODE_ENV !== "development" || !isBrowserRuntime()) return;
  const measurementId = process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "";
  if (!measurementId.trim() || shouldEnableAnalytics()) return;
  // eslint-disable-next-line no-console
  console.info(
    "[TheRallyAlly analytics] Dev GA4 collection is off. Set REACT_APP_ANALYTICS_DEBUG=true in .env.local and restart npm start, or run localStorage.setItem('shuttlescore_analytics_debug','1') and reload."
  );
}

export function isBrowserRuntime() {
  return typeof window !== "undefined" && typeof document !== "undefined";
}

export function isTestEnvironment() {
  return process.env.NODE_ENV === "test";
}

export function isProductionBuild() {
  return process.env.NODE_ENV === "production";
}

/** Explicit dev override (never enabled in tests or production builds). */
export function isAnalyticsForceEnabled() {
  if (isTestEnvironment()) return false;
  if (process.env.NODE_ENV !== "development") return false;
  return process.env.REACT_APP_ANALYTICS_FORCE === "true";
}

/**
 * DebugView / verbose collection in local development only when opted in.
 * Aligns with `features/analytics` until bridges migrate here.
 */
export function isAnalyticsDebugEnabled() {
  if (isTestEnvironment()) return false;
  if (process.env.NODE_ENV !== "development") return false;
  if (process.env.REACT_APP_ANALYTICS_DEBUG === "true") return true;
  if (!isBrowserRuntime()) return false;
  try {
    return window.localStorage?.getItem(DEBUG_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

/** Whether Firebase Analytics should initialize and send events. */
export function shouldEnableAnalytics() {
  if (!isBrowserRuntime()) return false;
  if (isTestEnvironment()) return false;
  if (isProductionBuild()) return true;
  return isAnalyticsForceEnabled() || isAnalyticsDebugEnabled();
}
